import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getLabelMessage } from '@gef-ui/localization/messages';
import CircleInfoSolid from '@gef-ui/material-icons/CircleInfoSolid';

import { equalOrThreeDashes, stringToDate } from 'utils';

export const LastModified = ({ date }) => {
	const formattedFeedbackDate = equalOrThreeDashes(stringToDate(date));

	return (
		<Stack direction="row" spacing={1}>
			<CircleInfoSolid sx={{ color: 'info.main' }} />
			<Typography sx={{ fontWeight: 'bold' }}>{`${getLabelMessage(
				'semaphore:feedbackLastModified',
			)} ${formattedFeedbackDate}`}</Typography>
		</Stack>
	);
};

LastModified.propTypes = {
	date: PropTypes.string,
};

export default LastModified;
